<script>
import debounce from 'lodash/debounce';

// components
import Result from './result';

export default {
  components: {
    Result
  },
  computed: {
    cursor () { return this.$store.state.databaseSearch.cursor },
    searching () { return this.$store.state.databaseSearch.searching },
    results () { return this.$store.state.databaseSearch.results },
    totalCount () { return this.$store.state.databaseSearch.totalCount },
    hasNextPage () { return this.$store.state.databaseSearch.hasNextPage }
  },
  mounted () {
    const self = this;

    // window.addEventListener('scroll', debounce( function(event) {
    //   if ( !self.searching && self.hasNextPage && window.scrollY >= ( self.$el.offsetHeight - window.innerHeight - 600 ) ) {
    //     self.$store.dispatch('databaseSearch/getNextResults');
    //   }
    // }, 100));
  }
}
</script>

<template lang="html">
  <div class="DatabaseSearch-results">
    <p class="DatabaseSearch-results-count" v-if="!!results.length">Showing {{results.length }} of {{ totalCount }} Results</p>

    <ol class="ListingGrid u-mt2" v-if="!!results.length">
      <li class="ListingGrid-item" v-for="(item, index) in results">

        <result v-if="item.node.type === 'Person'"
          label="Person"
          :path="item.node.path"
          :title="item.node.full_name"
          :meta="'Party: ' + item.node.party_name"></result>

        <result v-if="item.node.type === 'District'"
          label="District"
          :path="item.node.path"
          :title="item.node.name"
          :meta="item.node.state_name"></result>

        <result v-if="item.node.type === 'Election'"
          label="Election"
          :path="item.node.path"
          :title="item.node.name"
          :meta="item.node.year"></result>

      </li>
    </ol>

    <div v-if="hasNextPage" class="u-center u-mt4">
      <button @click="$store.dispatch('databaseSearch/getNextResults')" type="button" class="Button Button--outline">
        Load More
      </button>
    </div>

    <div class="DatabaseSearch-loading">
      <div v-if="searching && !!cursor" class="DatabaseSearch-spinner"></div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// results.vue?46b4553e